import { CalculationRevisionKey, markProjectCalculationDone } from "@/services/dashboard-process";

export interface ProcessProject {
    projectId: string;
    projectBoomerId: number;
    baamerRevisionId: string;
    newBoomerRevision: boolean;
}

export interface ProcessCallbackContext {
    project: ProcessProject;
    isActive: () => boolean;
    sendCalculatedData: (ignoreValidated: boolean) => Promise<void>;
}

const completeCalculation = (revisionKey: CalculationRevisionKey, ignoreValidated?: boolean) =>
    async (context: ProcessCallbackContext) => {
        if (!context.isActive()) return;
        await markProjectCalculationDone(context.project.projectId, revisionKey, context.isActive);
        if (context.isActive() && ignoreValidated !== undefined) {
            await context.sendCalculatedData(ignoreValidated);
        }
    };

// Cette map est reconstruite au chargement de l'application, indépendamment des pages.
const processCallbacks = new Map<string, (context: ProcessCallbackContext) => Promise<void>>([
    ["Calcul PDF Simples", completeCalculation("revMetresDepuisCalcul")],
    ["PDF Superposes - Calcul Package 1&2", completeCalculation("revCalcul1", true)],
    ["PDF Superposes - Calcul Package 3", completeCalculation("revCalcul2", false)],
    ["PDF Superposes - Calcul Package 4", completeCalculation("revCalcul3", true)],
    ["BAAMER :: Export : Promoter Surfaces (GOe)", completeCalculation("revSurfaces", false)],
]);

export default processCallbacks;
